export default __webpack_public_path__ + "static/media/home_back_arrow.fab769a7.svg";